enum GroupBaysPairedEnum {
  "NOT_GROUPED" = 1,
  "GROUPED" = 2,
}

export default GroupBaysPairedEnum;
